module.exports = "/fonts/vendor/@mdi/materialdesignicons-webfont.woff2?dc85ceeb0daba687e36d8dde4ed4d352";